import { WebProtocol } from 'src/constants/web';

export const getPageProtocol = (window: Window | null): string =>
  window && window.location && window.location.protocol
    ? window.location.protocol
    : WebProtocol.HTTP;
